<div class="container ps-4 pe-4">
  <form [formGroup]="form">

    <div *ngIf="componentContext==='graph-page'" class="mb-4">
      <mat-radio-group [value]="regionFilter" (change)="onRegionChange($event.value)">
        <mat-radio-button value="kinneret" class="me-3">Lake Kinneret</mat-radio-button>
        <mat-radio-button value="med">Mediterranean Sea</mat-radio-button>
      </mat-radio-group>
    </div>

    <div *ngIf="componentContext==='graph-page'">
      <mat-form-field class="example-full-width">
        <input type="text" required="true" #autoTreeInput placeholder="Select Variables" matInput (input)="filterChanged($event)" [matAutocomplete]="auto" />
        <mat-autocomplete (opened)="opened()" [panelWidth]="auto" #auto="matAutocomplete">
          <mat-option class="hidden" disabled></mat-option>
          <mat-tree [dataSource]="variablesCategories" [treeControl]="treeControl">
            <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding>
              <button mat-icon-button disabled></button>
              <div class="checklist-leaf-node pointer">
                <mat-checkbox [checked]="isVariableSelected(node)" (change)="todoLeafItemSelectionToggle(node)">
                  {{ node.item | variableDisplayName: publicNamesMap }}
                </mat-checkbox>
              </div>
            </mat-tree-node>

            <mat-tree-node class="node" *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
              <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.filename">
                <mat-icon class="mat-icon-rtl-mirror">{{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}</mat-icon>
              </button>
              <div class="pointer">{{ node.item }}</div>
            </mat-tree-node>
          </mat-tree>
        </mat-autocomplete>
      </mat-form-field>

      <mat-chip-set class="mt-2 mb-3" aria-label="Selected Variables" *ngIf="form.controls.column.value.length > 0">
        <mat-chip *ngFor="let item of form.controls.column.value" (removed)="removeVariable(item)" removable>
          {{ item | variableDisplayName: publicNamesMap }}
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip>
      </mat-chip-set>
    </div>

    <div *ngIf="componentContext==='dataset-page'">
      <mat-form-field appearance="fill">
        <mat-label>Choose a Variable</mat-label>
        <mat-select [(value)]="selectedDatasetPageVariables" (selectionChange)="onSelectDatasetPageVariable($event.value)" multiple>
          <mat-option *ngFor="let variable of datasetPageVariablesList" [value]="variable">
            {{ variable | variableDisplayName: publicNamesMap }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-chip-set class="mt-2 mb-3" aria-label="Selected Stations" *ngIf="selectedDatasetPageVariables.length>0">
        <mat-chip color="accent" *ngFor="let item of selectedDatasetPageVariables; let i=index" (removed)="removeDatasetPageVariable(i, item)">
          {{ item | variableDisplayName: publicNamesMap }}
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip>
      </mat-chip-set>
    </div>

    <mat-form-field>
      <mat-label>Select Station(s)</mat-label>
      <mat-select [formControl]="form.controls['station']" multiple (closed)="stationFilterControl.setValue('')">

        <mat-option class="search-option">
          <div class="search-input-container">
            <mat-icon class="search-icon">search</mat-icon>
            <input
              matInput
              placeholder="Search stations..."
              [formControl]="stationFilterControl"
              autocomplete="off"
              (click)="$event.stopPropagation()" />
          </div>
        </mat-option>

        <mat-option *ngFor="let station of filteredStations" [value]="station.title" (click)="toggleStation(station.title)">
          {{ station.title }}
        </mat-option>

      </mat-select>
    </mat-form-field>

    <mat-chip-set class="mt-2 mb-3" aria-label="Selected Stations" *ngIf="selectedStations.length>0">
      <mat-chip color="accent" *ngFor="let stationTitle of selectedStations" (removed)="removeStation(stationTitle)">
        {{ stationTitle }}
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip>
    </mat-chip-set>

    <div class="row mt-3">
      <mat-form-field [class.mb-5]="form.controls['fromDate'].hasError('minDate')">
        <mat-label>Select a date range</mat-label>
        <mat-date-range-input [rangePicker]="picker" [min]="availableDateMin" [max]="availableDateMax">
          <input matStartDate placeholder="Start date" formControlName="fromDate">
          <input matEndDate placeholder="End date" formControlName="toDate">
        </mat-date-range-input>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>

        <mat-error *ngIf="form.controls['fromDate'].hasError('minDate')">
          Start date cannot be earlier than {{ minDate | date:'dd/MM/yyyy' }}.
        </mat-error>
      </mat-form-field>
    </div>

    <div class="row mt-2 mb-3">
      <mat-radio-group formControlName="depthMode" class="radio-group" (ngModelChange)="onDepthModeChange()">
        <mat-radio-button value="singleDepth">Single Depth</mat-radio-button>
        <mat-radio-button value="rangeDepth">Range Depth</mat-radio-button>
      </mat-radio-group>
    </div>

    <!-- Single Depth Input -->
    <div *ngIf="form.controls['depthMode'].value === 'singleDepth'">
      <mat-form-field>
        <mat-label>Depth</mat-label>
        <mat-select formControlName="singleDepth">
          <mat-option *ngFor="let depth of availableSingleDepths" [value]="depth">
            {{ depth }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- From Depth and To Depth Inputs -->
    <div *ngIf="form.controls['depthMode'].value === 'rangeDepth'">
      <mat-form-field>
        <mat-label>From Depth</mat-label>
        <mat-select formControlName="fromDepth">
          <mat-option *ngFor="let depth of availableSingleDepths" [value]="depth">
            {{ depth }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-label>To Depth</mat-label>
        <mat-select formControlName="toDepth">
          <mat-option *ngFor="let depth of availableSingleDepths" [value]="depth">
            {{ depth }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Depth Aggregation</mat-label>
        <mat-select formControlName="depthAggregation">
          <mat-option value="max">Max</mat-option>
          <mat-option value="min">Min</mat-option>
          <mat-option value="mean">Mean</mat-option>
          <mat-option value="sum">Sum</mat-option>
          <mat-option value="integration">Integration</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <mat-form-field>
      <mat-label>Data Aggregation</mat-label>
      <mat-select formControlName="dataType">
        <mat-option value="raw">Raw</mat-option>
        <mat-option value="max">Max</mat-option>
        <mat-option value="min">Min</mat-option>
        <mat-option value="mean">Mean</mat-option>
        <mat-option value="std">STD</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="form.controls.dataType.value!=='raw'">
      <mat-label>Time Step</mat-label>
      <mat-select formControlName="timeSteps">
        <mat-option value="weekly">Weekly</mat-option>
        <mat-option value="monthly">Monthly</mat-option>
        <mat-option value="yearly">Yearly</mat-option>
      </mat-select>
    </mat-form-field>

    <div *ngIf="formErrorMessage" class="alert alert-danger text-center mt-3 mb-0" role="alert">
      {{ formErrorMessage }}
    </div>

    <div class="d-flex flex-column text-center mt-3">
      <button #animatedButton mat-raised-button color="primary" (click)="onSubmit()" class="mb-4">Visualize</button>
      <button mat-stroked-button (click)="onReset()">Reset</button>
    </div>
  </form>
</div>
